import React from 'react';
import { MailIcon, ZapIcon, DatabaseIcon, BarChart3Icon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
const features = [{
  name: 'Built-in B2B Data',
  description: 'Unlike other email sequence software, we provide the verified local business owner emails you need to start prospecting immediately.',
  icon: DatabaseIcon
}, {
  name: 'Advanced Personalization',
  description: 'Use 50+ data points (tech stack, revenue, location) as dynamic variables in your email sequences to dramatically increase reply rates.',
  icon: UsersIcon
}, {
  name: 'Multi-Touch Campaigns',
  description: 'Build complex B2B email sequences with automated follow-ups, delays, and conditional logic based on prospect engagement.',
  icon: MailIcon
}, {
  name: 'High Deliverability',
  description: 'Our email sequence CRM includes built-in email validation and sender reputation protection to ensure you land in the primary inbox.',
  icon: ShieldCheckIcon
}, {
  name: 'Native CRM Sync',
  description: 'Log CRM sequences emails calls automatically. Seamless integration for teams looking for HubSpot email sequences or Salesforce sync.',
  icon: ZapIcon
}, {
  name: 'Actionable Analytics',
  description: 'Track opens, clicks, replies, and bounces in real-time. A/B test your subject lines and copy to optimize your sales outreach.',
  icon: BarChart3Icon
}];
export function SequenceFeatures() {
  return <div className="bg-slate-50 py-24 sm:py-32" data-id="element-1511">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-1512">
        <div className="mx-auto max-w-2xl lg:text-center" data-id="element-1513">
          <div className="text-base font-semibold leading-7 text-blue-600 uppercase tracking-wider" data-id="element-1514">
            Features
          </div>
          <h2 className="mt-2 text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1515">
            Everything you need for{' '}
            <span className="text-blue-600" data-id="element-1516">B2B email sequences</span>
          </h2>
          <p className="mt-6 text-lg leading-8 text-slate-600" data-id="element-1517">
            The best email sequence software for sales teams targeting local
            businesses. We combine the data you need with the outreach tools you
            want.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none" data-id="element-1518">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3" data-id="element-1519">
            {features.map(feature => <div key={feature.name} className="flex flex-col bg-white p-8 rounded-3xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-1520">
                <dt className="flex items-center gap-x-3 text-lg font-bold leading-7 text-slate-900" data-id="element-1521">
                  <div className="h-10 w-10 flex items-center justify-center rounded-lg bg-blue-50" data-id="element-1522">
                    <feature.icon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-1523" />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-slate-600" data-id="element-1524">
                  <p className="flex-auto" data-id="element-1525">{feature.description}</p>
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </div>;
}